// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.cfje7D8VXPUKOd4NESaA {
  width: 100%;
}
table.cfje7D8VXPUKOd4NESaA th .n6qMCB85FAJCmpaqyN8u {
  height: 1rem;
  width: 1rem;
}

.t9XLxt85gPxfszQcihjS:hover,
.vixgtm9df5mw7w8E1oXg {
  border-color: #7a7a7a !important;
}

.wmAcLMc4BQWcNpq4GigV {
  margin-left: 0.5rem;
}

.GM4oXpt5eAQqxYQupm9d {
  color: #2e323a !important;
  border-color: #4a4a4a !important;
  background-color: #fff;
}

.sQ8nI6P3JZFJykmpjNxV {
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./packages/common/utils/components/src/lib/Table/Table.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACI;EACE,YAAA;EACA,WAAA;AACN;;AAIA;;EAEE,gCAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,yBAAA;EACA,gCAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;AADF","sourceRoot":""}]);
// Exports
var _1 = `cfje7D8VXPUKOd4NESaA`;
export { _1 as "common-table" };
export var icon = `n6qMCB85FAJCmpaqyN8u`;
export var isSortable = `t9XLxt85gPxfszQcihjS`;
export var isCurrentSort = `vixgtm9df5mw7w8E1oXg`;
export var tableIcon = `wmAcLMc4BQWcNpq4GigV`;
export var currentPage = `GM4oXpt5eAQqxYQupm9d`;
export var level = `sQ8nI6P3JZFJykmpjNxV`;
export default ___CSS_LOADER_EXPORT___;
